<template>
    <div v-if="showitembeforeadded == 'true'">
        <div class="basket-list-item py-3 mb-3" v-if="giftitem != null" :class="{'notgivengift': currentbasketvalue < warenwert}">
            <slot name="before-basket-item"></slot>

            <div class="basket-item component-loading with-icon d-flex">
                <div class="image-container">
                   <img :src="giftitem.images.all[0].urlPreview" class="img-fluid" loading="lazy">
                </div>

                <div class="meta-container-wrapper">
                    <div class="meta-container-wrapper-inner">
                        <div class="meta-container">
                            <div class="position-relative w-100">
                                <a :href="giftitem | itemURL" class="item-name text-primary text-appearance  font-weight-bold text-break">
                                    {{ giftitem | itemName }}
                                </a>
                                <p v-if="textgiftadd && giftgiven" v-html="textgiftadd"></p>
                                <p v-if="textgiftnotadded && giftgiven != true" v-html="textgiftnotadded"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="basket-list-item py-3 mb-3" v-if="giftitem != null && currentbasketvalue > warenwert">
            <slot name="before-basket-item"></slot>

            <div class="basket-item component-loading with-icon d-flex">
                <div class="image-container">
                    <img :src="giftitem.images.all[0].urlPreview" class="img-fluid" loading="lazy">
                </div>

                <div class="meta-container-wrapper">
                    <div class="meta-container-wrapper-inner">
                        <div class="meta-container">
                            <div class="position-relative w-100">
                                <a :href="giftitem | itemURL" class="item-name text-primary text-appearance  font-weight-bold text-break">
                                    {{ giftitem | itemName }}
                                </a>
                                <p v-if="textgiftadd && giftgiven" v-html="textgiftadd"></p>
                                <p v-if="textgiftnotadded && giftgiven != true" v-html="textgiftnotadded"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default
    {
        props:
        {
            variationid:
            {
                type: Number,
                default: 0
            },
            warenwert:
            {
                type:Number,
                default:0
            },
            textgiftadd:
            {
                type:String,
                default:null
            },
            textgiftnotadded:
            {
                type:String,
                default:null
            },
            currentbasketvalue:
            {
                type:Number,
                default:0
            },
            showitembeforeadded:
            {
                type:String,
                default:null
            }
        },
        data: function()
        {
            return {
                giftitemData: null
            }
        },

        created:function()
        {
            this.getitem();
        },
        methods:
        {
            getitem:function()
            {


                let _self               = this;
                let item                = this.variationid;
                let myPromise = new Promise(function(myResolve, myReject)
                {
                  $.ajax(
                  {
                      type:           'POST',
                      url:            '/itemsList/'+App.language+'/',
                      data:           {"items":[item]},
                      dataType:       'json',
                      success:        function(data)
                      {
                          myResolve(data[0].data);
                          //_self.giftitemData = data[0].data;

                      },
                      error:          function(jqXHR, textStatus, errorThrown)
                      {
                          // console.error(errorThrown);
                      }
                  });
                });


                myPromise.then
                (
                    function(value)
                    {
                      let data = value;
                      _self.giftitemData = data;
                    },
                    function(error) {
                      // console.log(error)
                    }
                );

            }
        },
        computed:
        {
            giftitem:function()
            {
                return this.giftitemData;
            },
            giftgiven:function()
            {
                let _self = this;
                if(_self.currentbasketvalue >= _self.warenwert )
                {
                    return true
                }
                else
                {
                    return false
                }
            }
        }
    }
</script>
